import React from 'react';
import cn from 'classnames';
import { ReactSVG } from 'react-svg';

interface IconProps {
  icon: string;
  isCornerRound?: boolean;
  className?: string;
  hasIconClass?: boolean;
  style?: React.CSSProperties;
}

const Icon = (props: IconProps) => {
  const {
    icon,
    isCornerRound,
    className,
    hasIconClass = true,
    ...rest
  } = props;
  return icon ? (
    <ReactSVG
      className={cn(icon, {
        Icon: hasIconClass,
        [className as string]: className !== null,
        'rounded-corners': isCornerRound,
      })}
      src={`/public/img/${icon}.svg`}
      {...rest}
    />
  ) : null;
};

export default Icon;
